(function (app) {

    app.provider("businessApi",
    [
        function () {
            this.$get = [
                "complianceHubApiGateway", function (complianceHubApiGateway) {
                    var service = {};

                    //GETs
                    service.get = function(businessId) {
                        return complianceHubApiGateway.get("/Businesses/" + businessId);
                    };

                    //service.getArcBusinesses = function() {
                    //    return complianceHubApiGateway.getArray("/Businesses/Arc");
                    //};

                    service.searchArcBusinesses = function (searchTerm) {
                        return complianceHubApiGateway.getArray("/Businesses/Arc?searchTerm=" + searchTerm);
                    };

                    service.getArcBusiness = function(businessId) {
                        return complianceHubApiGateway.get("/Businesses/" + businessId + "/Arc");
                    };

                    //PUTs

                    //POSTs
                    service.add = function(business) {
                        return complianceHubApiGateway.post("/Businesses", business).then(function (response) {
                            business.Id = response.Id;
                            return complianceHubApiGateway.post("/Businesses/" + business.Id + "/Arc", business);
                        });
                    };


                    //service.createBusiness = function(business) {
                    //    return complianceHubApiGateway.post("/Businesses/", { Name: business.Name })
                    //        .then(function(b) {
                    //            business.Id = b.Id;
                    //            return complianceHubApiGateway.post("/Businesses/" + b.Id + "/Arc/", business)
                    //                .then(function(bus) {
                    //                    return bus.Id;
                    //                });
                    //        });
                    //};

                    //DELETEs

                    return service;
                }
            ];
        }
    ]);
})(window.app); //jshint ignore:line